export class DateUtil {
    // Return date in format mm/dd/yyyy
    static formatDate = (date) => {
        if(!date) { return null;}

        date = new Date(date);

        return `${(date.getUTCMonth() + 1)}/${date.getUTCDate()}/${date.getUTCFullYear()}`;
    }

    // Return datetime in format mm/dd/yyyy, hh:mm AM/PM
    static formatTimestamp = (timestamp) => {
        if(!timestamp) { return null;}

        const date = new Date(timestamp);
        return date.toLocaleString('en-US', {
            hour12: true,
            hour: "numeric",
            minute: "2-digit",
            year: "numeric",
            month: "numeric",
            day: "numeric",
            timeZoneName:'short'
        });
    }
}